/* eslint-disable max-len */
/* eslint-disable no-plusplus */
import React from 'react';
import {
  Table,
} from 'reactstrap';
import { GetFormattedDate } from './FormatDate';

const PetList = ({ petList, openClient }) => {
  let i = petList ? petList.length : 0;
  return (
    <div>
      <Table
        responsive
        size="sm"
        bordered
        striped
        hover
        style={{ backgroundColor: '#e6f2ff', height: '1vw', overflowY: 'auto' }}
      >
        <thead>
          <tr>
            <th>#</th>
            <th>Pet Name</th>
            <th>Owner</th>
            <th>Gender</th>
            <th>Type</th>
            <th>Breed</th>
            <th>Last Treatment</th>
            <th>Last Vaccination</th>
          </tr>
        </thead>
        <tbody>
          {petList && petList.map(pet => (
            <tr
              key={pet.value}
              onClick={() => { openClient(pet.owner); }}
              style={{ cursor: 'pointer' }}
            >
              <td>
                {i--}
              </td>
              <td>
                {pet.label ? (
                  <div>
                    {pet.label}
                  </div>
                ) : (
                  <div />
                )}
              </td>
              <td>
                {pet.ownerName ? (
                  <div>
                    {pet.ownerName}
                  </div>
                ) : (
                  <div />
                )}
              </td>
              <td>
                {pet.gender ? (
                  <div>
                    {pet.gender}
                  </div>
                ) : (
                  <div />
                )}
              </td>
              <td>
                {pet.type.label ? (
                  <div>
                    {pet.type.label}
                  </div>
                ) : (
                  <div />
                )}
              </td>
              <td>
                {pet.breed.label ? (
                  <div>
                    {pet.breed.label}
                  </div>
                ) : (
                  <div />
                )}
              </td>
              <td>
                {pet.lastTreatment ? (
                  <div>
                    {GetFormattedDate(pet.lastTreatment.seconds * 1000)}
                  </div>
                ) : (
                  <div>
                    ----------
                  </div>
                )}
              </td>
              <td>
                {pet.lastVaccination ? (
                  <div>
                    {pet.lastVaccination.length > 0 ? (
                      <div>
                        {pet.lastVaccination.map(row => (
                          <div key={row.seconds}>
                            {GetFormattedDate(row.seconds * 1000)}
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div>
                        Formatting Error
                      </div>
                    )}
                  </div>
                ) : (
                  <div>
                    ----------
                  </div>
                )}
              </td>
            </tr>
          ))
        }
        </tbody>
      </Table>
    </div>
  );
};

export default PetList;
